import Component from "../core/Component"
import Scroll from "../services/Scroll"
import scrollTo from "../services/Viewport/scrollTo"

export default class ReadProgress extends Component {
   constructor(element) {
      super(element)

      this.SCROLL_OFFSET = 40 // side nav click top scroll offset
      this.HEADLINE_TYPE = "h2" // headline type to handle navigation

      this.header = document.querySelector(".Header")
      this.contentHeight
      this.contentTop
      this.contentBottom
      this.headerProgressBar
      this.headerHeight = header.offsetHeight
      this.offset = 0
      this.titles = []
      this.sideNav
      this.outlines
      this.windowHeight = window.innerHeight / 2 - this.headerHeight / 2
   }

   prepare() {

      Scroll.on("scroll", this.scrollPosition)

      this.createProgressBar()
      window.addEventListener("load", () => {
         this.getContentCoordinates()
         this.collectTitlesData()
         if (window.innerWidth >= 1600) {
            this.createSideNavigation()
            window.addEventListener("scroll", () => {
               this.highlightActiveNavItem()
               this.visibility(this.sideNav, this.windowHeight)
            })
         }
      })

      window.onresize = () => {
         this.getContentCoordinates()
         this.collectTitlesData()
         this.progressBarLogic()
      }

      window.addEventListener("scroll", () => {
         this.progressBarLogic()
         this.visibility(this.headerProgressBar, this.headerHeight)
      })
   }

   getContentCoordinates() {
      const content = this.element.getBoundingClientRect()
      this.contentTop = content.top + this.offset
      this.contentBottom = content.bottom + this.offset
      this.contentHeight = content.bottom - content.top
   }

   collectTitlesData() {
      this.titles = []
      const titles = this.element.querySelectorAll(this.HEADLINE_TYPE)
      titles.forEach((item) => {
         let obj = [{
            title: item.innerText,
            top: item.getBoundingClientRect().top + this.offset,
         }, ]
         let orig = this.titles
         this.titles = [...orig, ...obj]
      })
      let lastItem = [{
         title: "endpoint",
         top: this.contentTop + this.contentHeight,
      }, ]
      this.titles = [...this.titles, ...lastItem]
   }

   scrollPosition = ({
      offset
   }) => {
      this.offset = offset.y
   }

   createProgressBar() {
      let progressBarEl = document.createElement("div")
      progressBarEl.classList.add("Header-progressBar")
      this.header.appendChild(progressBarEl)
      this.headerProgressBar = progressBarEl
   }

   progressBarLogic() {
      if (this.headerProgressBar) {
         let articleScrollPosition = Math.round(Math.min(Math.max(this.offset - (this.contentTop - this.headerHeight), 0), this.contentHeight))
         let progressCalc = (articleScrollPosition / this.contentHeight) * 100
         this.headerProgressBar.style.width = progressCalc.toFixed(2) + "%"
      }
   }

   createSideNavigation() {
      let articleNav = document.createElement("nav")
      articleNav.classList.add("article-outline")
      let ul = document.createElement("ul")

      this.titles.forEach((item, index) => {
         if (index == this.titles.length - 1) return
         let navItem = document.createElement("li")
         navItem.innerHTML = `<span>${item.title}</span>`
         ul.appendChild(navItem)
      })

      articleNav.appendChild(ul)
      document.body.appendChild(articleNav)
      this.sideNav = articleNav
      this.outlines = articleNav.querySelectorAll("li")
      this.createAnchors()
   }

   createAnchors() {
      this.outlines.forEach((item, index) => {
         item.addEventListener("click", () => {
            scrollTo(this.titles[index].top - this.headerHeight - this.SCROLL_OFFSET)
         })
      })
   }

   visibility(el, offset = 0) {
      if (this.offset > this.contentTop - offset && this.offset < this.titles[this.titles.length - 1].top - offset) {
         el.classList.add("visible")
      } else {
         el.classList.remove("visible")
      }
   }

   highlightActiveNavItem() {
      this.outlines.forEach((title, index) => {
         if (this.offset + this.windowHeight > this.titles[index].top && this.offset + this.windowHeight < this.titles[index + 1].top) {
            this.outlines[index].children[0].classList.add("active")
         } else {
            this.outlines[index].children[0].classList.remove("active")
         }
      })
   }
}